module.exports = __webpack_public_path__ + "img/Boxes.c7f4a41a.png";